import './common/list/hashtag-list';
import './common/list/article-list';
import Header from './modules/header';
window.addEventListener('DOMContentLoaded', () => {
  new Header();
});

/* search.js - 検索ページのUI制御 */
(() => {
  "use strict";

  function updatePageMeta() {
    const params = new URLSearchParams(location.search);
    const hashtagParam = params.get("hashtag");

    // タグをパース
    let tags = [];
    let tagDisplay = "";
    let tagForMeta = "";

    if (hashtagParam) {
      tags = hashtagParam
        .split(/[,\s]+/)
        .map((t) => t.trim())
        .filter(Boolean);

      if (tags.length > 0) {
        tagDisplay = tags.map((t) => `#${t}`).join(" / ");
        tagForMeta = tags.map((t) => `#${t}`).join(", ");
      }
    }

    // H1を更新
    const titleEl = document.querySelector(".m-heading2-text");
    if (titleEl) {
      titleEl.textContent = tagDisplay ? `${tagDisplay} 記事一覧` : "全記事一覧";
    }

    // ページタイトルを更新 (<title>)
    const pageTitle = tagDisplay
      ? `${tagDisplay} 記事一覧 | 解放美区 | 資生堂`
      : "記事一覧 | 解放美区 | 資生堂";
    document.title = pageTitle;

    // ディスクリプションを更新 (meta description, og:description, twitter:description)
    const pageDescription = tagForMeta
      ? `${tagForMeta}で絞り込んだ記事の一覧ページです。気になる記事を見つけて読んでみよう。`
      : "記事の一覧ページです。気になる記事を見つけて読んでみよう。";

    document.querySelector('meta[name="description"]')?.setAttribute("content", pageDescription);
    document.querySelector('meta[property="og:title"]')?.setAttribute("content", pageTitle);
    document.querySelector('meta[property="og:description"]')?.setAttribute("content", pageDescription);
    document.querySelector('meta[name="twitter:title"]')?.setAttribute("content", pageTitle);
    document.querySelector('meta[name="twitter:description"]')?.setAttribute("content", pageDescription);

    // Canonical URLを更新
    const canonicalUrl = tagForMeta
      ? `https://www.shiseido.co.jp/kaiho-biku/search/?hashtag=${encodeURIComponent(hashtagParam)}`
      : "https://www.shiseido.co.jp/kaiho-biku/search/";
    document.querySelector('link[rel="canonical"]')?.setAttribute("href", canonicalUrl);

    // og:urlを更新
    document.querySelector('meta[property="og:url"]')?.setAttribute("content", canonicalUrl);

    // application/ld+jsonを更新
    const ldJsonEl = document.querySelector('script[type="application/ld+json"]');
    if (ldJsonEl) {
      try {
        const ldJson = JSON.parse(ldJsonEl.textContent);
        ldJson.name = tagDisplay ? `${tagDisplay} 記事一覧` : "記事一覧";
        ldJson.description = pageDescription;
        ldJson.url = canonicalUrl;
        ldJsonEl.textContent = JSON.stringify(ldJson, null, 2);
      } catch (e) {
        console.warn("[search.js] Failed to update ld+json", e);
      }
    }
  }

  // DOM読み込み時にメタ情報を更新
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updatePageMeta);
  } else {
    updatePageMeta();
  }
})();
